import { ComponentRoute } from '@/classes'

const VehicleLookupRoutes = {
  VehicleLookupListView: new ComponentRoute('/vehiclelookup', 'VehicleLookupListView'),
  // VehicleLookupView: new ComponentRoute('/vehiclelookup/:calllogid', 'VehicleLookupView'),
  VehicleLookupDetail: new ComponentRoute('/vehiclelookup/:callLogId', 'VehicleLookupDetail')
}

export default VehicleLookupRoutes
